// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Hotel from '../_raw/service/icon_hotel.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Hotel);
